export class Booking {


  public bookingId: string;
  public accountId: string;
  public bookingTimeFrom: Date;
  public bookingTimeTo: Date;
  public status: string;
  public bookingDateTime: Date;
  public registDate: Date;
  public registPname: string;
  public lastUpdateDate: Date;
  public lastUpdatePname: string;
  public actionBy: string;

  constructor(
      bookingId: string,
      accountId: string,
      bookingTimeFrom: Date,
      bookingTimeTo: Date,
      status: string,
      bookingDateTime: Date,
      registDate: Date,
      registPname: string,
      lastUpdateDate: Date,
      lastUpdatePname: string) {

          this.bookingId = bookingId;
          this.accountId = accountId;
          this.bookingTimeFrom = bookingTimeFrom;
          this.bookingTimeTo = bookingTimeTo;
          this.status = status;
          this.bookingDateTime = bookingDateTime;
          this.registDate = registDate;
          this.registPname = registPname;
          this.lastUpdateDate = lastUpdateDate;
          this.lastUpdatePname = lastUpdatePname;

  }
}
